import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3),
      boxShadow: '0 0 10px 1px rgba(0,0,0,0.13)',
    },
    loading: {
      marginRight: theme.spacing(2),
    },
    title: {
      textAlign: 'center',
    },
  }),
);

interface Props {
  title?: string;
  classes?: any;
  loading?: boolean;
  center?: boolean;
}

const CustomPaper: React.FC<Props> = ({ title, children, loading, center }) => {
  const [showLoading, setShowLoading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    const timer = loading ? setTimeout(() => setShowLoading(true), 700) : null;
    return () => {
      timer && clearTimeout(timer);
    };
  }, [loading]);

  return (
    <Paper elevation={0} className={classes.root}>
      {title && (
        <Container className={classes.title}>
          <Typography variant="h1">{title}</Typography>
        </Container>
      )}
      <Grid container justifyContent={center ? 'center' : 'flex-start'}>
        {loading && showLoading ? (
          <CircularProgress size={24} className={classes.loading} />
        ) : (
          children
        )}
      </Grid>
    </Paper>
  );
};

export default CustomPaper;
